// Google Ads purchase conversions (AW-18535382541). The landing site loads the same tag; the console reports
// one conversion per paid invoice (top-ups are not purchases: their money is counted when it buys something).
const AW_ID = 'AW-18535382541';
const PURCHASE = 'AW-18535382541/6X5rCJbowKgdEI38rYZF';
// GA4 (same property as the landing site): sign_up is sent there as a recommended event, so it can be
// marked as a key event in GA4 and imported into Google Ads.
const GA4_ID = 'G-9EKBQN4ZW7';
// Google Ads "sign-up" conversion action label (AW-…/xxxx). Empty until the action exists in Google Ads.
const SIGNUP = '';
let loaded = false;

export function loadAdsTag() {
    if (loaded || typeof window === 'undefined' || typeof document === 'undefined') return;
    loaded = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', AW_ID);
    window.gtag('config', GA4_ID);
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${AW_ID}`;
    document.head.appendChild(s);
}

/** Report a paid invoice once (per browser; Google also dedups by transaction_id). */
export function reportPurchase(invoice) {
    if (!invoice || invoice.invoice_type === 'topup') return;
    const value = parseFloat(invoice.total_amount || 0);
    const tx = String(invoice.invoice_number || invoice.id || '');
    if (!tx || !(value > 0)) return;
    const key = `ads:conv:${tx}`;
    try {
        if (window.localStorage.getItem(key)) return;
        window.localStorage.setItem(key, '1');
    } catch (e) {
        // storage blocked: still report (transaction_id dedups on Google's side)
    }
    loadAdsTag();
    window.gtag('event', 'conversion', {
        send_to: PURCHASE,
        value,
        currency: String(invoice.currency || 'USD').toUpperCase(),
        transaction_id: tx,
    });
}

/** Report a new account once per browser (email sign-up, or first sign-in with Google / GitHub). */
export function reportSignup(method) {
    try {
        if (window.localStorage.getItem('ads:signup')) return;
        window.localStorage.setItem('ads:signup', '1');
    } catch (e) {
        // storage blocked: report anyway
    }
    loadAdsTag();
    window.gtag('event', 'sign_up', { method: method || 'email' });
    if (SIGNUP) {
        window.gtag('event', 'conversion', { send_to: SIGNUP });
    }
}
